/**
 * Detects whether the app is currently executing under Cypress (or a coverage
 * harness that re-uses the same gating). Returns true only inside the AUT
 * window — never in a customer's browser.
 *
 * Backed by three independent signals so we still detect Cypress even if one
 * is unavailable in a given run mode (component vs e2e, headless vs open):
 *   1. window.Cypress — injected by Cypress into the application-under-test
 *      window.
 *   2. sessionStorage['__cypress_test__'] — set by cypress/support/e2e.ts at
 *      the start of every spec so the flag survives full reloads.
 *   3. import.meta.env.VITE_COVERAGE — sourced from .env during local
 *      dev/coverage builds.
 *
 * Use this gate around any client code that calls test-only endpoints or
 * mutates shared infrastructure. Server-side env checks are defence-in-
 * breadth, this is defence-in-depth.
 */
export function isCypress(): boolean {
	return (
		typeof window !== 'undefined' &&
		((window as any).Cypress !== undefined ||
			window.sessionStorage.getItem('__cypress_test__') !== null ||
			import.meta.env.VITE_COVERAGE === 'true')
	)
}
